export const ADORNMENT_VARIANTS = {
  outline: 'outline',
  underline: 'underline',
  client_card: 'client_card',
  inline: 'inline',
} as const;
